<template>
  <div class="customization">
    <div class="animated fadeIn">
      <b-row v-for="(f, i) in fields" :key="i+0">
        <b-col cols="2">
          <legend class="col-form-label">{{$t('client.label')}}</legend>
        </b-col>
        <b-col cols="10" class="form-group">
          <b-form-input class="form-control border-radius-4px" v-model="fields[i].title" />
        </b-col>
        <b-col cols="2">
          <legend class="col-form-label">{{$t('client.position')}}</legend>
        </b-col>
        <b-col cols="5">
          <selected-position v-model="fields[i].position"></selected-position>
        </b-col>
        <b-col cols="5" class="form-group">
          <b-form-select class="form-control border-radius-4px" v-model="fields[i].position.field" :options="position_fields"/>
        </b-col>
        <b-col cols="2">
          <legend class="col-form-label">{{$t('client.field')}}</legend>
        </b-col>
        <b-col cols="10" class="form-group">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>{{$t('client.input_type')}}</th>
              <th>{{$t('client.name')}}</th>
              <th>{{$t('client.options')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(b, j) in fields[i].body" :key="j+0">
              <td>
                <b-form-select class="form-control border-radius-4px" v-model="fields[i].body[j].input_type" :options="input_types"/>
              </td>
              <td>
                <b-form-input class="form-control border-radius-4px" v-model="fields[i].body[j].name" />
              </td>
              <td>
                <table>
                  <tr>
                    <td>{{$t('client.class')}}</td>
                    <td><b-form-input class="form-control border-radius-4px" v-model="fields[i].body[j].options.class" /></td>
                  </tr>
                  <tr>
                    <td>{{$t('client.rows')}}</td>
                    <td><b-form-input class="form-control border-radius-4px" v-model="fields[i].body[j].options.rows" /></td>
                  </tr>
                  <tr>
                    <td>{{$t('client.default')}}</td>
                    <td><b-form-input class="form-control border-radius-4px" v-model="fields[i].body[j].options.default" /></td>
                  </tr>
                  <tr>
                    <td>{{$t('client.readonly')}}</td>
                    <td><c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="fields[i].body[j].options.readonly" :value="true" :uncheckedValue="false"/></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="3"><button type="button" class="btn btn-danger border-radius-4px" @click="remove(i)"><i class="fa fa-trash-o"></i> {{$t('common.remove')}}</button> </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <button type="button" class="btn bg-main border-radius-4px" @click="add">{{$t('common.add')}}</button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import cSwitch from '../../../components/Switch'
  import SelectedPosition from './SelectPosition'

  export default {
    name: 'Customization',
    props: {
      value: {
        type: Array,
        default: []
      },
      position_fields: {
        type: Array,
        default: []
      }
    },
    components: {
      cSwitch,
      SelectedPosition
    },
    data: function () {
      return {
        input_types: [
          {
            text: this.$t('client.input'),
            value: 'input'
          },
          {
            text: this.$t('client.textarea'),
            value: 'textarea'
          },
          {
            text: this.$t('client.switch'),
            value: 'switch'
          },
          {
            text: this.$t('client.masked-input'),
            value: 'masked-input'
          }
        ],
        field: {
          title: '',
          body: [
            {
              input_type: '',
              name: '',
              options: {
                default: '',
                class: 'form-control border-radius-4px',
                type: 'text',
                readonly: false
              }
            }
          ],
          position: {
            after: false,
            before: true,
            field: ''
          }
        },
        fields: []
      }
    },
    methods: {
      remove (i) {
        let fields = []
        for (let j in this.fields) {
          if (i != j) {
            fields.push(this.fields[j])
          }
        }
        this.fields = this._.cloneDeep(fields)
      },
      add () {
        this.fields.push(this._.cloneDeep(this.field))
      },
      updateData (value) {
        for (let i in value) {
          if (value != null && value[i] != null) {
            this.fields[i] = value[i]
          }
        }
        this.$forceUpdate('fields')
      }
    },
    created: function () {
      for (let i in this.value) {
        if (this.value != null && this.value[i] != null) {
          this.fields[i] = this.value[i]
        }
      }
    },
    mounted: function () {
    },
    watch: {
      fields: {
        handler: function (newValue) {
          this.$emit('input', this.fields)
          this.$emit('change', this.fields)
        },
        deep: true
      },
      value: {
        handler: function (newValue) {
          this.updateData(newValue)
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .table td {
    padding: 5px 0.75rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/client/Customization.vue